var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRuby(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 2490,
    viewBox: "0 0 256 255",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "84.75%",
    y1: "111.399%",
    x2: "58.254%",
    y2: "64.584%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB7655",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB7655",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E42B1E",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#900",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#900",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "116.651%",
    y1: "60.89%",
    x2: "1.746%",
    y2: "19.288%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#871101",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#871101",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#911209",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#911209",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.774%",
    y1: "219.327%",
    x2: "38.978%",
    y2: "7.829%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#871101",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#871101",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#911209",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#911209",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.012%",
    y1: "7.234%",
    x2: "66.483%",
    y2: "79.135%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E57252",
    offset: "23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE3B20",
    offset: "46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A60003",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A60003",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.174%",
    y1: "16.348%",
    x2: "49.932%",
    y2: "83.047%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4714E",
    offset: "23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE1A0D",
    offset: "56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D00",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.965%",
    y1: "15.594%",
    x2: "49.528%",
    y2: "92.478%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E46342",
    offset: "18%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C82410",
    offset: "40%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D00",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "13.609%",
    y1: "58.346%",
    x2: "85.764%",
    y2: "-46.717%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C81F11",
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0905",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0905",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "27.624%",
    y1: "21.135%",
    x2: "50.745%",
    y2: "79.056%",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4024",
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF190B",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF190B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-20.667%",
    y1: "122.282%",
    x2: "104.242%",
    y2: "-6.342%",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0012",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0012",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "17%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C82F1C",
    offset: "27%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#820C01",
    offset: "33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A31601",
    offset: "46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B31301",
    offset: "72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E82609",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E82609",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.792%",
    y1: "65.205%",
    x2: "11.964%",
    y2: "50.128%",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C0C01",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C0C01",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#990C00",
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D0E",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D0E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "79.319%",
    y1: "62.754%",
    x2: "23.088%",
    y2: "17.888%",
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E110B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E110B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E0C00",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E0C00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "92.88%",
    y1: "74.122%",
    x2: "59.841%",
    y2: "39.704%",
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79130D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79130D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E120B",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E120B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "32.001%",
    cy: "40.21%",
    fx: "32.001%",
    fy: "40.21%",
    r: "69.573%",
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E0E08",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E0E08",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "13.549%",
    cy: "40.86%",
    fx: "13.549%",
    fy: "40.86%",
    r: "88.386%",
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A30C00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A30C00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800E08",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800E08",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "56.57%",
    y1: "101.717%",
    x2: "3.105%",
    y2: "11.993%",
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2114",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2114",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E100A",
    offset: "43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3100C",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3100C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "30.87%",
    y1: "35.599%",
    x2: "92.471%",
    y2: "100.694%",
    id: "p"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B31000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B31000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#910F08",
    offset: "44%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#791C12",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#791C12",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.467 167.764l-145.52 86.41 188.422-12.787L254.88 51.393l-57.414 116.37z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.677 241.257L224.482 129.48l-44.113 58.25 60.308 53.528z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240.896 241.257l-118.646-9.313-69.674 21.986 188.32-12.673z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.744 253.955l29.64-97.1L17.16 170.8l35.583 83.154z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.358 188.05L153.085 81.226l-78.047 73.16 105.32 33.666z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.693 82.73l-73.777-60.256-20.544 66.418 94.321-6.162z",
    fill: "url(#f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M214.191.99L170.8 24.97 143.424.669l70.767.322z",
    fill: "url(#g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 203.372l18.177-33.151-14.704-39.494L0 203.372z",
    fill: "url(#h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.496 129.48l14.794 41.963 64.283-14.422 73.39-68.207 20.712-65.787L143.063 0 87.618 20.75c-17.469 16.248-51.366 48.396-52.588 49-1.21.618-22.384 40.639-32.534 59.73z",
    fill: "#FFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.442 54.094c37.86-37.538 86.667-59.716 105.397-40.818 18.72 18.898-1.132 64.823-38.992 102.349-37.86 37.525-86.062 60.925-104.78 42.027-18.73-18.885.515-66.032 38.375-103.558z",
    fill: "url(#i)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.744 253.916l29.408-97.409 97.665 31.376c-35.312 33.113-74.587 61.106-127.073 66.033z",
    fill: "url(#j)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M155.092 88.622l25.073 99.313c29.498-31.016 55.972-64.36 68.938-105.603l-94.01 6.29z",
    fill: "url(#k)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M248.847 82.833c10.035-30.282 12.35-73.725-34.966-81.791l-38.825 21.445 73.791 60.346z",
    fill: "url(#l)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 202.935c1.39 49.979 37.448 50.724 52.808 51.162l-35.48-82.86L0 202.935z",
    fill: "#9E1209"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M155.232 88.777c22.667 13.932 68.35 41.912 69.276 42.426 1.44.81 19.695-30.784 23.838-48.64l-93.114 6.214z",
    fill: "url(#m)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M82.113 156.507l39.313 75.848c23.246-12.607 41.45-27.967 58.121-44.42l-97.434-31.428z",
    fill: "url(#n)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.174 171.34l-5.57 66.328c10.51 14.357 24.97 15.605 40.136 14.486-10.973-27.311-32.894-81.92-34.566-80.814z",
    fill: "url(#o)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M174.826 22.654l78.1 10.96c-4.169-17.662-16.969-29.06-38.787-32.623l-39.313 21.663z",
    fill: "url(#p)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuby);
export default __webpack_public_path__ + "static/media/ruby.320ed4681bc48df897b0ed0ff4b00559.svg";
export { ForwardRef as ReactComponent };